/* eslint-disable */
import React from "react";
import './LogoShort.scss';
function LogoShort() {
  return (
    <svg
    className="logoShort"
      xmlns="http://www.w3.org/2000/svg"
      width="319.882"
      height="141.221"
      version="1.1"
      viewBox="0 0 84.635 37.365"
    >
      <g transform="translate(-11.802 -15.457)">
        <g transform="translate(-3.745 -1.925)">
          <path
            fill="rgb(255, 255, 255)"
            fillOpacity="1"
            strokeWidth="0.03"
            d="M51.128 38.863c-1.522-2.38-6.77-10.65-6.763-10.656.015-.014 16.876.042 18.857.062 1.456.015 1.817.026 1.805.055-.015.038-5.352 8.512-6.295 9.996-.3.473-.575.894-.612.936l-.066.077-2.089-3.185c-1.59-2.423-2.107-3.19-2.164-3.21-.057-.019-.12-.006-.264.054-.104.043-.19.09-.19.104 0 .04.14.288.642 1.134.255.43.463.805.463.833a.635.635 0 01-.075.19c-.109.198-1.835 2.852-2.514 3.863-.163.244-.222.293-.348.295-.02 0-.194-.247-.387-.548z"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default LogoShort;
